import { render, staticRenderFns } from "./SimulationEsg.vue?vue&type=template&id=36ba99a8&scoped=true"
import script from "./SimulationEsg.vue?vue&type=script&lang=js"
export * from "./SimulationEsg.vue?vue&type=script&lang=js"
import style0 from "./SimulationEsg.vue?vue&type=style&index=0&id=36ba99a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ba99a8",
  null
  
)

export default component.exports